import moment, { Moment } from 'moment';

import { EIGHT_DAY_WITH_A_WEEK_IN_BETWEEN } from 'modules/campaigns/components/ccm/utils/ccm-timeline';

export function isDayBlocked(day: Moment, currentDate: null | string): boolean {
  const dayOfWeek = day.format('dddd').toLowerCase();

  if (dayOfWeek === 'saturday' || dayOfWeek === 'sunday') {
    return true;
  }

  if (currentDate !== null) {
    // allow any day beyond the already selected date
    return !day.isAfter(moment(currentDate));
  }

  // prevent the first seven days after today's date from being selected
  return day.isBefore(moment().startOf('day').add(EIGHT_DAY_WITH_A_WEEK_IN_BETWEEN, 'd'));
}

export function getInitialVisibleMonth(currentDate: null | string): Moment {
  if (currentDate !== null) {
    // open whatever month the campaign's date is in
    return moment(currentDate);
  }

  // open whatever month the first allowed date is in
  return moment().startOf('day').add((EIGHT_DAY_WITH_A_WEEK_IN_BETWEEN + 1), 'd');
}
